// ── Palette ───────────────────────────────────────────────────────
export const NAVY   = "#072C76";
export const GOLD   = "#F4C120";
export const WHITE  = "#FFFFFF";
export const DANGER = "#E03C3C";
